import { render, staticRenderFns } from "./BasicDeleteTeamTournamentMlbb.vue?vue&type=template&id=a9303892&scoped=true"
import script from "./BasicDeleteTeamTournamentMlbb.vue?vue&type=script&lang=js"
export * from "./BasicDeleteTeamTournamentMlbb.vue?vue&type=script&lang=js"
import style0 from "./BasicDeleteTeamTournamentMlbb.vue?vue&type=style&index=0&id=a9303892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9303892",
  null
  
)

export default component.exports